<template>
  <div>
    <div class="row" >
      <div v-if="expertDetails" class="col-xs-12 well" >
        <div class="clearfix"></div>
        <div class="row m-b" style="margin-top: 10px" v-if="expertDetails.keywords.length">
          <div class="col-md-2 col-xs-12 col-sm-3 item-label">
            <span>Areas of expertise : </span>
          </div>
          <div class="col-md-10 col-xs-12 col-sm-9">
            <span v-for="(item, key) in expertDetails.keywords" :key="key">
              {{item.keyword.keyword}}
            <template v-if="key < expertDetails.keywords.length - 1 ">,</template>
            </span>
          </div>
        </div>

        <div class="row m-b" style="padding-top: 10px" v-if="author.company" >
          <div class="col-md-2 col-xs-12 col-sm-3 item-label">
            <span>Affiliation :</span>
          </div>
          <div class="col-md-10 col-xs-12 col-sm-9">
            <div class="row">
              <div class="col-xs-3 col-xs-offset-2 col-sm-offset-0 item-label">
                <span>City </span>
              </div>
              <div class="col-xs-7 col-sm-9">
                <span v-if="!author.company.city">Incomplete</span>
                <span v-else>{{author.company.city}}</span>
              </div>
              <div class="col-xs-3 col-xs-offset-2 col-sm-offset-0 item-label">
                <span>Country </span>
              </div>
              <div class="col-xs-7 col-sm-9">
                <span v-if="!author.company.country || !author.company.name">Incomplete</span>
                <span v-else>{{author.company.country.name}}</span>
              </div>
              <div class="col-xs-3 col-xs-offset-2 col-sm-offset-0 item-label">
                <span>Name </span>
              </div>
              <div class="col-xs-7 col-sm-9">
                <span v-if="!author.company || !author.company.name">Incomplete</span>
                <span v-else>{{author.company.name}}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="row" style="padding-top: 10px" v-if="expertDetails.orcid">
          <div class="col-md-2 col-xs-12 col-sm-3 item-label">
            <span>ORCID iD: </span>
          </div>
          <div class="col-md-10 col-xs-12 col-sm-9">
            <span  title="Click to open ORCID profile"> <a :href="'https://orcid.org/'+expertDetails.orcid" target="_blank"> <i class="fab fa-orcid  text-success"></i></a></span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style>
  .item-label {
    font-weight: bold;
  }
  .coAuthors-divider + .coAuthors-divider:before {
    content: ", ";
  }
  .selected {
    border-left: 5px solid #34495e;
  }

</style>
<script>

import DocumentAction from './DocumentAction'
export default {
  name: 'LocalAuthorDetails',
  components: {DocumentAction},
  props: ['value', 'author', 'context', 'pubDateSelected'],
  data () {
    return {
      expertDetails: null
    }
  },
  beforeMount () {
    this.expertDetails = this.value.length ? this.value[0] : null
  }

}
</script>



// WEBPACK FOOTER //
// src/components/documents/LocalAuthorDetails.vue